import { render, staticRenderFns } from "./ProductRoleInformation.vue?vue&type=template&id=51df2640"
import script from "./ProductRoleInformation.vue?vue&type=script&lang=js"
export * from "./ProductRoleInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports